import convertVttToJson from 'vtt-to-json';

export class audioSync {

  constructor(options) {
    this.options = options;
    this.syncData = [];
  }

  init() {
    return new Promise((resolve, reject) => {
      fetch(new Request(this.options.subtitlesFile))
        .then(response => response.text())
        .then((text) => this.createSubtitle(text))
        .then((data) => {
          this.syncData = data;
          resolve(data)
        })
    });
  }

  createSubtitle(text) {
      let data = [];
      convertVttToJson(text)
        .then((result) => {
            var x = 0;
            for (var i = 0; i < result.length; i++) { //cover for bug in vtt to json here
                if (result[i].part && result[i].part.trim() != '') {
                  data[x] = result[i];
                    x++;
                }
            }
        });

      return data;
  }

  renderSubtitle() {
    this.syncData.forEach((element, index, array) =>{
      var el;
      el = document.createElement('span');
      el.innerText = this.syncData[index].part;
      el.setAttribute("id", "c-" + index);
      this.subtitles.appendChild(el);
    });
  }

  timeUpdate() {
      this.audioPlayer.addEventListener("timeupdate", (e) => {
          this.syncData.forEach((element, index, array) => {
              if( (this.audioPlayer.currentTime*1000) >= element.start && (this.audioPlayer.currentTime*1000) <= element.end ) {
    
              let el = document.getElementById('c-' + index);
    
               if(!el) return;
    
                el.classList.add('active');
                scrollToElm(this.subtitles, el , 300 );
              }
          });
      });
  }
}


/////////////

export const scrollToElm = (container, elm, duration) => {
  var pos = getRelativePos(elm);

  let height = container.clientHeight;

  let mathPos = Math.max( (pos.top - height /2) + 20, 0);

  scrollTo(container, mathPos, duration/1000);  // duration in seconds
}

function getRelativePos(elm){
  var pPos = elm.parentNode.getBoundingClientRect(), // parent pos
      cPos = elm.getBoundingClientRect(), // target pos
      pos = {};

  pos.top    = cPos.top    - pPos.top + elm.parentNode.scrollTop,
  pos.right  = cPos.right  - pPos.right,
  pos.bottom = cPos.bottom - pPos.bottom,
  pos.left   = cPos.left   - pPos.left;

  return pos;
}
    
function scrollTo(element, to, duration, onDone) {
    var start = element.scrollTop,
        change = to - start,
        startTime = performance.now(),
        val, now, elapsed, t;

    function animateScroll(){
        now = performance.now();
        elapsed = (now - startTime)/1000;
        t = (elapsed/duration);

        element.scrollTop = start + change * easeInOutQuad(t);

        if( t < 1 )
            window.requestAnimationFrame(animateScroll);
        else
            onDone && onDone();
    }

    animateScroll();
}

function easeInOutQuad(t){ return t<.5 ? 2*t*t : -1+(4-2*t)*t }